import { render, staticRenderFns } from "./ReductCodePanel.vue?vue&type=template&id=463ab135&scoped=true&"
import script from "./ReductCodePanel.vue?vue&type=script&lang=js&"
export * from "./ReductCodePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ab135",
  null
  
)

export default component.exports